import { render, staticRenderFns } from "./CommentAssignedForm.vue?vue&type=template&id=3d10eba5&scoped=true"
import script from "./CommentAssignedForm.vue?vue&type=script&lang=js"
export * from "./CommentAssignedForm.vue?vue&type=script&lang=js"
import style0 from "./CommentAssignedForm.vue?vue&type=style&index=0&id=3d10eba5&prod&lang=css"
import style1 from "./CommentAssignedForm.vue?vue&type=style&index=1&id=3d10eba5&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d10eba5",
  null
  
)

export default component.exports